import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import EpicEntrances from "./sections/EpicEntrances";
import CoreDirective from "./sections/CoreDirective";
import ProjectCapabilities from "./sections/ProjectCapabilities";
import Testimonials from "./sections/Testimonials";
import StudioMetrics from "./sections/StudioMetrics";
import SupportInquiry from "./sections/SupportInquiry";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <EpicEntrances />
      <CoreDirective />
      <ProjectCapabilities />
      <Testimonials />
      <StudioMetrics />
      <SupportInquiry />
      <Footer />
    </div>;
}